// Redux-backed breadcrumb resolvers.
// When a future slice migrates, remove its entry here and add the
// corresponding block in src/hooks/useQueryBreadcrumbs.ts.
export const breadcrumbResolvers = {
  patient: ({ patient }) => patient.detailViewData,
  customer: ({ customer }) => customer.detailViewData,
  formulary: ({ customer }) => customer.customerAssignedFormulary,
  user: ({ user }) => user.detailViewData,
  sso: ({ user }) => user.detailSsoViewData,
  layout: ({ layouts }) => layouts.deatilLayout,
  form: ({ forms }) => forms.formDetailsData,
  assessment: ({ patient }) => patient.detailAssessment,
};
